var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assign from './assign';
import nodeFactory, { register } from './factory';
import { Size } from './IPadding';
import Type from './Type';
export * from './IPadding';
function isIOptions(init) {
    return typeof init === 'object' && init !== null && typeof init.node === 'object';
}
function options(init) {
    return isIOptions(init) ? init : { node: init };
}
export class Generic {
    constructor(init) {
        this.type = Type.Padding;
        const _a = options(init), {size, node, copy} = _a, rest = __rest(_a, [
                'size',
                'node',
                'copy'
            ]);
        this.size = size || Size.Normal;
        this.node = nodeFactory(node, copy);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.size.configurable = false;
        descriptors.node.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Padding extends Generic {
}
export const klass = Padding;
export default Padding;
register(Type.Padding, Padding);    //# sourceMappingURL=Padding.js.map
